<div class="viewport-1">
  <background #background></background>
  <img id="fil-logo" class="overlay-fil-logo" [ngClass]="{'fade-out': goToStartAnimation}" src="/assets/images/wordflight_vrt_color_pos_rgb.svg" />
  <div id="login-box" class="login-form-wrapper" [ngClass]="{'pop-out': loggedIn, 'hidden': showUsage }" *ngIf="!restrictLogin">
      <div id="failedLoginDisplay" class="alert custom-alert font-15"
        [ngClass]="{'alert-info': alertStatus === AlertStatus.INFO, 'alert-danger': alertStatus === AlertStatus.ERROR}"
         *ngIf="alertStatus !== AlertStatus.HIDDEN">
        {{result}}
      </div>
      <label class="login-text-label">Login</label>
      <form name="studentLoginForm" class="form login-form" [formGroup]="loginForm" (ngSubmit)="login()">
          <div *ngIf="capsOn" class="caps-lock-warning">
            <div><img src="/assets/images/caps-lock.svg" height="16" width="16" /></div>
            <div>Caps-lock is enabled</div>
          </div>
          <div class="student-form-group-wrapper">
            <div class="student-form-group">
                <label class="login-field-text font-27" for="username">Username</label>
                <label class="login-field-text font-27" for="password">Password</label>
            </div>
            <div class="student-form-group-inputs">
              <input type="text" id="username" name="username" formControlName="username" class="input-medium login-field  font-27" required autofocus>
              <input type="password" id="password" name="password" formControlName="password" class="input-medium login-field font-27" required>
            </div>
          </div>
          <button type="submit" [disabled]="!loginForm.valid || loginButtonDisabled" class="clear-btn btn-login"></button>
      </form>
      <div class="login-clever">
        <a [href]="cleverOauth"><img src="/assets/images/LogInWithClever.svg" width="207"/></a>
        <a [href]="classlinkOauth"><img src="/assets/images/LogInWithClassLink.png" style="width: 207px;" /></a>
      </div>
  </div>
  <div *ngIf="restrictLogin" class="download-element-message" style="font-weight: bold ; font-size: 2rem ;">
    <div>
      WordFlight works best on mobile devices and tablets when using the WordFlight app, get it now...
    </div>
    <div class="download-app-wrapper">
      <div class="download-app-btn">
        <a [href]="appStoreLink"><img src="/assets/images/app-icon.png" width="48" height="48"/> WordFlight</a>
      </div>
    </div>
  </div>
  <div class="usage-element-message" [hidden]="!showUsage">
    <p>
      Hi! You’ve been really active with WordFlight this week, and you’ve hit your weekly time limit.
      Congratulations on your hard work. We’ll see you next week!
    </p>
    <button class="btn btn-success" (click)="cancelLogin()">See you then</button>
  </div>
  <version-footer [ngClass]="{'fade-out': goToStartAnimation}"></version-footer>
</div>
